import { inject, observer } from "mobx-react";
import React, { Component, Fragment } from 'react';

@inject('igStore', 'dictStore')
@observer
class EventHeader extends Component {

  render() {
    const { game, reInit } = this.props.igStore;
    const { sid } = game;
    const { getLang } = this.props.dictStore;
    return <Fragment>
      <div className={`ig-event-header s-c-${sid}`}>
        <div className="ig-teams">
          <div className="ig-team">
            <div className="ig-team-shield"/>
            <div className="ig-team-text ig-team-text--locked"/>
          </div>
          <div className="ig-team">
            <div className="ig-team-shield"/>
            <div className="ig-team-text ig-team-text--locked"/>
          </div>
        </div>
      </div>
      <div className="ig-item-wrapper">
        <div className="ig-error">
          <span className="ig-error__text">{getLang('CONNECTION_FAILED')}</span>
          <button className="flat_button flat_button_w" onClick={reInit}>{getLang('RETRY')}</button>
        </div>
      </div>
    </Fragment>
  }
}

export default EventHeader;


// WEBPACK FOOTER //
// ./src/components/ig/error.js